import { render, staticRenderFns } from "./tabPrint.vue?vue&type=template&id=ff239f90&scoped=true&"
import script from "./tabPrint.vue?vue&type=script&lang=js&"
export * from "./tabPrint.vue?vue&type=script&lang=js&"
import style0 from "./tabPrint.vue?vue&type=style&index=0&id=ff239f90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff239f90",
  null
  
)

export default component.exports